import { Padrao } from '../generic/padrao';

export class EndEstadoAliquota extends Padrao{

    override idTab = 165;

    icms: number;
}
